import React, { useEffect, useRef, useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from "../../util/CommonUtils";
import API from '../../service/SiteKickAPIService';

const SiteWeather = (props) => {

    var sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let isMount = useRef(true);
    const [weather, setWeather] = useState(null);

    useEffect(() => {
        fetchWeatherInformation(props.site.site_id);
        return () => isMount.current = false;
    }, [props.site.site_id]);

    let fetchWeatherInformation = (site_id) => {
        isMount.current = true;
        var data = {
            site_id: site_id, //this.props.site.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        CommonUtils.ajax(
            {
                url: API.DATA.WEATHER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let weatherData = null;
                    if (res.data && res.data.length > 0)
                        weatherData = res.data[0];
                    if (isMount.current)
                        setWeather(weatherData);
                }
            },
            (res) => {

            });
    }

    const weather_rec = {};
    var img = '';

    if (weather) {
        let weatherJSON = weather.full_response;

        if (weatherJSON.weather && weatherJSON.weather.length > 0) {
            let weatherObj = weatherJSON.weather[0];
            weather_rec.icon = <img src={"https://openweathermap.org/img/wn/" + weatherObj.icon + ".png"} alt="Weather" width="20"></img>;
        }

        weather_rec.temperature = weather.temperature.replace(' F', '');
        var temperature = (Math.round(weather_rec.temperature * 100) / 100).toFixed();
        weather_rec.humidity = weather.humidity.replace(' %', '');;

        weather_rec.precipitation = weather.precip_1hr_string.replace(' in', '');
        var precipitation = (Math.round(weather_rec.precipitation * 100) / 100).toFixed(1);
        precipitation = precipitation ? precipitation + ' in/hr' : '';

    }
    return (
        weather && (
            <>
                <span className="mr-4">{img}</span>
                <span className="mr-4">{CommonUtils.formatSensorData('temperature', temperature)}</span>
                <span className="mr-4">{CommonUtils.formatSensorData('humidity', weather_rec.humidity)}</span>
                <span className="mr-4">{weather_rec.icon} {precipitation}</span>
            </>
        )
    );
}

export default SiteWeather;